import styled from "styled-components";
import { titleCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Avatar, Divider } from "@mui/material";

import pages from "../../constants/pages";
import cashkaro from "../../assets/cashkaro_logo_v1.svg";

import DropDownButton from "./navbar components/DropDownButton";

const ImageDiv = styled.div`
  width: 150px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  gap: 10px;
  margin-bottom: 4px;
`;

const Wrapper = styled.div`
  min-height: 80px;
  border-radius: 0px;
  background: #fff;
  padding: 10px;
  display: flex;
  position: sticky;
  top: 0;
  z-index: 1199;
  justify-content: space-between;
  box-shadow: 0 5px 5px -5px rgba(35, 37, 38, 0.15);
`;

const BrandDiv = styled.div`
  display: flex;
`;

export default function Navbar({ sidebarState, setSelectedMenu }) {
  const navigate = useNavigate();
  const uiDetails = useSelector((state) => state.renderUIDetails);
  const { dashboardPermissions } = useSelector((state) => state.memberDetails);

  const { activeBrand, role, agency, parentState } = useSelector(
    (state) => state.memberDetails
  );

  return (
    <Wrapper>
      <div style={{ display: "flex", alignSelf: "center" }}>
        <IconDiv>
          {sidebarState.open && (
            <ImageDiv
              onClick={() => {
                const isAdminBrand = dashboardPermissions.some(
                  (page) => page.ID === "administrator-brands"
                );

                const path = isAdminBrand
                  ? pages.accountVerification.route
                  : pages.brandDetails.route;

                navigate(path);
                setSelectedMenu(path);
              }}
            >
              <Image src={cashkaro} alt="Logo" />
            </ImageDiv>
          )}
        </IconDiv>
      </div>

      <BrandDiv>
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          {(role === "NORMAL_USER" ||
            role === "AGENCY" ||
            role === "SUPER_ADMIN") && (
            <div
              className="brand-switch-logo"
              onClick={() => {
                if (role === "NORMAL_USER" || role === "AGENCY") {
                  navigate(pages.welcomePage.route);
                }

                if (role === "SUPER_ADMIN" || parentState === "SA") {
                  navigate(pages.adminWelcomePage.route);
                }
              }}
            >
              <Avatar
                style={{
                  height: "25px",
                  width: "25px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                src={role === "AGENCY" ? agency.agencyLogo : activeBrand.logo}
              />
              {role === "AGENCY" && titleCase(agency.agencyName)}{" "}
              {role === "NORMAL_USER" && titleCase(activeBrand.brandName)}
              {role === "SUPER_ADMIN" && "Superadmin"}
            </div>
          )}

          <Divider
            orientation="vertical"
            flexItem
            style={{ height: "50px", marginRight: "10px" }}
          />

          <DropDownButton />
        </div>
      </BrandDiv>
    </Wrapper>
  );
}
